import { useCallback, useEffect, useState } from 'react';
import { useAPIContext, useStoreContext } from '../../../../components/Context';
import { getDraftPayment } from '../../draft/payment/selectors';
import { getZoneName } from '../../zone/selectors';
import { createAsyncState } from '../hooks';
import { useCallbackRef } from '../../../../utils';
export var useCouponVersionAsync = createAsyncState('couponVersion');
export var useCouponActivateRequest = function () {
    var couponActivate = useAPIContext().couponActivate;
    var state = useStoreContext()[0];
    var payment = getDraftPayment(state);
    var zoneName = getZoneName(state);
    var _a = useCouponVersionAsync(), asyncState = _a[0], actions = _a[1];
    var _b = useState(), body = _b[0], setBody = _b[1];
    var activateHandler = useCallbackRef(function (coupon) {
        if (zoneName && coupon && payment) {
            setBody({
                coupon: coupon,
                zone_name: zoneName,
                payment: {
                    payment_method_id: payment.id,
                    type: payment.type,
                },
            });
        }
    });
    useEffect(function () {
        if (couponActivate && body) {
            actions.start();
            return couponActivate({
                body: body,
                onSuccess: actions.success,
                onError: actions.error,
            });
        }
    }, [couponActivate, actions, body]);
    return [activateHandler, asyncState];
};
export var useCouponDeactivateRequest = function () {
    var couponDeactivate = useAPIContext().couponDeactivate;
    var _a = useCouponVersionAsync(), asyncState = _a[0], actions = _a[1];
    var _b = useState(), body = _b[0], setBody = _b[1];
    var deactivateHandler = useCallback(function (coupon) { return setBody({ coupon: coupon }); }, []);
    useEffect(function () {
        if (couponDeactivate && body) {
            actions.start();
            return couponDeactivate({
                body: body,
                onSuccess: actions.success,
                onError: actions.error,
            });
        }
    }, [couponDeactivate, deactivateHandler, actions, body]);
    return [deactivateHandler, asyncState];
};
